import { isNil } from 'lodash';

import { defaultWorkerPermissions } from '../default-worker-permissions';
import type { WorkerPermissionsEditorOutput } from '../worker-permissions-editor-output';
import type { WorkerPermissionsFormType } from '../worker-permissions-form-type';

export const formToWorkerPermissionsEditorOutput = (
  formType: WorkerPermissionsFormType,
): WorkerPermissionsEditorOutput | undefined => {
  if (isNil(formType) || isNil(formType.join)) {
    return defaultWorkerPermissions;
  }

  return {
    join: formType.join,
  };
};
